import React from 'react';
import { motion } from 'framer-motion';

// <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
//   <rect x="7.15039" width="56" height="10.1111" rx="5.05556" transform="rotate(45 7.15039 0)" fill="#171616"/>
//   <rect x="47.1211" y="7.46777" width="56" height="10.1111" rx="5.05556" transform="rotate(135 47.1211 7.46777)" fill="#171616"/>
// </svg>

const delay = 0.1;

const MenuIcon = () => {
  return (
    <motion.svg
      width="40"
      height="40"
      viewBox="0 0 57 49"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <motion.rect
        variants={{
          open: {
            rotateZ: 45,
            y: 20,
            transition: {
              delay,
            },
          },
          closed: {
            y: 0,
            rotateZ: 0,
          },
        }}
        width="56"
        height="10.1111"
        rx="5.05556"
        fill="currentColor"
      />
      <motion.rect
        variants={{
          open: {
            rotateZ: -45,
            y: 20,
            transition: {
              delay,
            },
          },
          closed: {
            y: 40,
            rotateZ: 0,
          },
        }}
        x="0"
        width="56"
        height="10.1111"
        rx="5.05556"
        fill="currentColor"
      />
      <motion.path
        variants={{
          open: {
            scaleX: 0.01,
            scaleY: 0.5,
            opacity: 0,
            translateX: -12,
            translateY: -8,
            transition: {
              delay,
            },
          },
          closed: {
            scaleX: 0.7,
            scaleY: 0.7,
            translateX: -12,
            translateY: -9,
            opacity: 1,
          },
        }}
        width="40"
        height="20"
        x="0"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.17788 23.1098C2.77409 19.8943 6.67472 18.5817 9.89017 20.1779L41.1328 35.6873L69.9321 20.2695C73.097 18.5752 77.0361 19.7673 78.7305 22.9321C80.4248 26.097 79.2327 30.0361 76.0678 31.7305L44.3131 48.7305C42.4589 49.7231 40.2389 49.7573 38.3551 48.8221L4.10978 31.8221C0.894324 30.2259 -0.418331 26.3252 1.17788 23.1098Z"
        fill="currentColor"
      />
    </motion.svg>
  );
};

export default MenuIcon;
